import React from "react";
import { Box, Typography } from "@mui/material";
import stop from "assets/images/stop.png";
import BGbzu from "assets/images/bg-bzu.png";

const BottomBar = ({ title, homeText, managementText }) => {
  return (
    <Box
      sx={{
        height: "120px",
        marginTop: "10px",
        marginBottom: "24px",
        borderRadius: "5px",
        backgroundColor: "rgba(40, 22, 111, 0.11)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {/* Left Content: Title and Text */}
      <Box
        sx={{ display: "flex", flexDirection: "column", marginLeft: "36px" }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: {
              xs: "1.1rem",
              sm: "1.5rem",
              md: "2rem",
              lg: "2.5rem",
            },
          }}
        >
          {title}
        </Typography>

        {/* Icon and Text Row */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1" sx={{ marginRight: "8px" }}>
            {homeText}
          </Typography>
          <img
            src={stop}
            alt="Stop"
            style={{
              width: "5px",
              height: "5px",
              marginRight: "8px",
            }}
          />
          <Typography variant="body1"
          >{managementText}</Typography>
        </Box>
      </Box>

      {/* Right Image */}
      <img src={BGbzu} alt="Background Image" />
    </Box>
  );
};

export default BottomBar;
